<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
    <wep-loading :is-loading="isLoading"/>
  </div>
</template>
<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
import WepLoading from '~pages/contents/loading/WepLoading.vue'

export default {
  name: 'OnAir',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate, 'wep-loading': WepLoading
  },
  data () {
    return {
      includeHtml: '',
      videoSrc: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      wepSets: this.getStore('mmpAuth').state.wepSets,
      isLoading: false
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepOnAir.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    openNotice () {
      document.querySelectorAll('.notice-item')[0].classList.toggle('opened')
    },
    async fnGoLogin () {
      let params = {
        mbrFnm: '',
        emailAddr: '',
        ifLinkYn: 'N'
      }
      let result = {}
      result = this.documentValidate()
      if (result.flag) {
        params.mbrFnm = result.input[0].data.trim()
        params.emailAddr = result.input[1].data.trim()
        params.wepId = this.getStore('mmpAuth').state.saveId
        let resultInfo = await this.$http.mmp.memberInfo(this, params)

        if (resultInfo.data.status !== 'OK') {
          this.isLoading = false
          if (params.emailAddr === '') {
            this.commAlert(this.$t('WEP00054'))
          } else {
            this.commAlert(this.$t('WEP00014'))
          }
        } else {
          if (resultInfo.data.data.wepAplConfmCd === 'S') {
            let session = Object.assign({}, {
              loginTime: new Date().getTime(),
              timeout: window.vue.config.session.timeout,
              authenticated: true,
              wepId: resultInfo.data.data.wepId,
              userId: resultInfo.data.data.wepApcId,
              mbrFnm: resultInfo.data.data.mbrFnm,
              emailAddr: resultInfo.data.data.emailAddr,
              wepApcTyp: resultInfo.data.data.wepApcTyp
            })
            this.getStore('root').commit('LOG_IN', session)
            let token = Object.assign({}, {
              tokenAuth: resultInfo.data.data.mbrToken
            })
            this.getStore('token').commit('REGISTER', token)
            this.getStore('mmpAuth').commit('SET_AUTO_LOGIN', {session: session, token: token})
            this.isLoading = false
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'onAirLogin',
                category: '(목표) onAir',
                action: '웨비나 로그인'
              })
            }
            if (this.wepSets.videoTrnsTyp === '02' ) {
              this.getTemplate('wepAgenda.html', '0', 'classnow')
            } else if (this.wepSets.videoTrnsTyp === '03' ) {
              this.getTemplate('wepAgenda.html', '0', 'classnow')
            } else {
              this.getTemplate('wepEnter.html', '0', 'enter')
            }
          } else if (resultInfo.data.data.wepAplConfmCd === 'A') {
            // this.fnAlert(this.$t('WEP00024'))
            this.isLoading = false
            this.commAlert(this.$t('WEP00024'))
          } else if (resultInfo.data.data.wepAplConfmCd === 'C') {
            this.isLoading = false
            this.commAlert(this.$t('WEP00025'))
          } else {
            this.isLoading = false
            this.commAlert(this.$t('WEP00033'))
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/OnAir.vue